// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__FQ0Va","label":"Radio_label__3UjTZ","checkMark":"Radio_checkMark__Xx3R6","disabled":"Radio_disabled__1gV8D"};